export function goToUrl(url: string): void {
  window.location.href = url
}
